import React, { Fragment } from 'react';
import SideNav from '../../Components/SideNav';

import icon1 from "../../Images/Icon/67.png"
import icon2 from "../../Images/Icon/68.png"
import icon3 from "../../Images/Icon/69.png"
import icon4 from "../../Images/Icon/70.png"

import "./Estudiantes.css"
import { Link } from 'react-router-dom';

const Estudiantes = () => {

    return(
        <Fragment>
            <SideNav />
            <div>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    Estudiantes
                </p>
                <div className='flex_padre'>
                    <Link to="/estudiantes-pdf/0" className='box_estudiantes'>
                        <img src={icon1} alt="" />
                        <p>
                            Horarios
                        </p>
                    </Link>
                    <Link to="/estudiantes-pdf/1" className='box_estudiantes'>
                        <img src={icon2} alt="" />
                        <p>
                            Horarios <br/>
                            de examenes
                        </p>
                    </Link>

                    <Link to="/estudiantes-pdf/3" className='box_estudiantes'>
                        <img src={icon3} alt="" />
                        <p>
                            Derecho <br/>
                            a examen
                        </p>
                    </Link>

                    <Link to="/estudiantes-pdf/2" className='box_estudiantes'>
                        <img src={icon4} alt="" />
                        <p>
                            Calificaciones
                        </p>
                    </Link>
                </div>
            </div>
        </Fragment>
    )
}

export default Estudiantes;